export default {
  Form: require('./Form').default,
  List: require('./List').default,
  Detail: require('./Detail').default,
}